import TextWithEllipsis from './textWithEllipsis.view';

export default TextWithEllipsis;
